import { render } from "./Parametro.vue?vue&type=template&id=2b27b678"
import script from "./Parametro.vue?vue&type=script&lang=js"
export * from "./Parametro.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__